<template>
  <div>
    <div v-if="$vuetify.breakpoint.mdAndUp">
      <v-speed-dial v-model="fab" :direction="direction" :open-on-hover="hover" :transition="transition">
        <template v-slot:activator>
          <v-btn v-model="fab" v-b-tooltip.hover="'عملیات'" fab icon x-small>
            <v-icon v-if="fab" color="pink darken-1 icon-xl-2x">mdi-close</v-icon>
            <v-icon v-else class="icon-xl-2x" color="black">mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <template v-for="(item, index) in meta.buttons">
          <v-btn v-if="!!item.status ? can(item.status) : true" :key="index" v-b-tooltip.hover.top="item.label"
                 :class="classBtn + item.class" fab small @click="item.action(data, item.name)">
            <v-icon :class="iconClass + item.icon"></v-icon>
          </v-btn>
        </template>
      </v-speed-dial>
    </div>

    <div v-else>
      <div class="mt-3 row justify-content-center px-0">
        <v-btn v-for="(item, index) in meta.buttons" v-if="can(item.status)" :key="index"
               v-b-tooltip.hover.top="item.label" :class="classBtn + item.class" class="m-1 col-5"
               @click="item.action(data, item.name)">
          <v-icon :class="iconClass + item.icon"/>
          {{ item.label }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import {can} from "@/core/plugins/acl";

export default {
  name: "buttons",

  props: {
    data: {},
    action: {
      type: Function,
    },
    meta: {
      type: Object,
    }
  },

  data() {
    return {
      classBtn: 'btn btn-sm text-center ',
      iconClass: 'px-1 text-center icon-md fa fa-',
      direction: 'right',
      color: {
        'edit': 'warning',
        'delete': 'error',
        'show': 'info',
        "refresh": 'indigo',
      },
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: 'slide-x-reverse-transition',
    };
  },

  watch: {
    top(val) {
      this.bottom = !val
    },
    right(val) {
      this.left = !val
    },
    bottom(val) {
      this.top = !val
    },
    left(val) {
      this.right = !val
    },
  },

  methods: {
    can
  }
}
</script>
